import { useCallback, useEffect } from 'react';
import { setIsColumnLayoutMode } from '../redux/actions/commonActions';
import { selectPanelPositionSetting } from '../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { getIsColumnLayoutMode } from '../utils/layoutModeUtils';
import { useDebouncedResizeHandler } from './useDebouncedResizeHandler';
/**
 * Handles resizing behavior for non-poker scenes.
 */
export function useSceneResize() {
    const dispatch = useAppDispatch();
    const isColumnLayoutMode = useAppSelector((state) => state.common.isColumnLayoutMode);
    const panelPositionSetting = useAppSelector(selectPanelPositionSetting);
    const handleResize = useCallback(() => {
        const newIsColumnLayoutMode = getIsColumnLayoutMode(panelPositionSetting);
        if (newIsColumnLayoutMode !== isColumnLayoutMode) {
            dispatch(setIsColumnLayoutMode(newIsColumnLayoutMode));
        }
    }, [dispatch, isColumnLayoutMode, panelPositionSetting]);
    useEffect(() => {
        handleResize();
    }, [handleResize]);
    useDebouncedResizeHandler(handleResize);
}
